import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { store } from '@/store/index';
import {
  readCompany,
  readSwitchableCompanies,
  readHasSwitchableCompanies,
  readForceEnroll2Fa,
} from '@/store/main/getters';
import { dispatchGetCompany } from '@/store/main/actionsMain';
import { Company } from '@/interfaces/vuex/company';
import { defineMessages } from '@/lib/i18n';
import { SDS_FILTER_LOCAL_STORAGE_KEY } from '@/composables/useSdsFilter';
import CompanySwitchConfirmDialog from './CompanySwitchConfirmDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySwitcher',
  setup(__props) {

const m = defineMessages({
  currentTenant: '表示中のテナント',
  searchTenantPlaceholder: 'テナントを検索...',
  noTenantsFound: '該当するテナントが見つかりません',
});

const currentCompany = computed(() => readCompany(store));
const switchableCompanies = computed(() => readSwitchableCompanies(store));
const hasSwitchableCompanies = computed(() =>
  readHasSwitchableCompanies(store)
);
const forceEnroll2Fa = computed(() => readForceEnroll2Fa(store));
// 2FA必須化で未設定の間は、必須化していない別テナントへ切り替えて制限を外せないようにする
const canSwitchCompany = computed(
  () => hasSwitchableCompanies.value && !forceEnroll2Fa.value
);

const currentCompanyName = computed(() => {
  return currentCompany.value?.name || '';
});

const menuOpen = ref(false);
const searchQuery = ref('');
const confirmDialogOpen = ref(false);
const targetCompany = ref<Company | null>(null);

const filteredCompanies = computed(() => {
  // Exclude the current company from the list
  const otherCompanies = switchableCompanies.value.filter(
    (company) => company.uuid !== currentCompany.value?.uuid
  );

  // Apply search filter if query exists
  if (!searchQuery.value) {
    return otherCompanies;
  }

  const query = searchQuery.value.toLowerCase();
  return otherCompanies.filter((company) =>
    company.name.toLowerCase().includes(query)
  );
});

const switchCompany = (company: Company) => {
  targetCompany.value = company;
  confirmDialogOpen.value = true;
  menuOpen.value = false; // Close the dropdown menu
};

const handleCancelSwitch = () => {
  confirmDialogOpen.value = false;
  targetCompany.value = null;
};

const handleConfirmSwitch = async () => {
  if (!targetCompany.value) return;

  try {
    // Save the selected company ID to localStorage for persistence across page reloads
    localStorage.setItem('selectedCompanyId', targetCompany.value.uuid);

    // Clear SDS list filters so they don't carry over to the new tenant
    localStorage.removeItem(SDS_FILTER_LOCAL_STORAGE_KEY);

    // Update the current company in the store
    await dispatchGetCompany(store, { companyId: targetCompany.value.uuid });

    // Reload the page to reinitialize with the new company context
    window.location.reload();
  } catch (error) {
    console.error('Failed to switch company:', error);
    confirmDialogOpen.value = false;
    targetCompany.value = null;
  }
};

return { __sfc: true,m, currentCompany, switchableCompanies, hasSwitchableCompanies, forceEnroll2Fa, canSwitchCompany, currentCompanyName, menuOpen, searchQuery, confirmDialogOpen, targetCompany, filteredCompanies, switchCompany, handleCancelSwitch, handleConfirmSwitch, CompanySwitchConfirmDialog }
}

})